export class SalaryPeriodType {
    id = null;
    name = null;
    code = null;
    description = null;
}